<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 login-max-w sm:m-0 m-4">
      <vs-alert class="mb-5" title="Nueva imagen " active="true">
        Queremos compartir una gran noticia contigo: DigitaFirma ahora es Verificamex. Puedes seguir accediendo con tus mismos datos.
      </vs-alert>
      <vx-card>
        <div slot="no-body" class="full-page-bg-color bg-wite">

          <div class="vx-row no-gutter justify-center">

            <div class="vx-col hidden lg:block lg:w-1/2 px-4 py-5 color-bg-login min-h-login">
              <div >
                <img class="mb-5 max-w-logo d-block m-auto" src="@/assets/images/logo/logo-full.svg" alt="registerImg">
                <img src="@/assets/images/pages/login.svg" alt="login" class="mx-auto">
              </div>
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container py-login">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Inicio</h4>
                  <p>Bienvenido de nuevo, inicia sesión en tu cuenta.</p>
                </div>

                <form @submit="submitLogin">
                  <div>

                    <vs-input
                        label-placeholder="Correo"
                        name="email"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        v-model="email"
                        class="w-full"/>

                    <vs-input
                        label-placeholder="Contraseña"
                        :type="type"
                        name="password"
                        icon-no-border
                        icon="icon icon-lock"
                        icon-pack="feather"
                        v-model="password"
                        class="w-full mt-6" />
                    <div class="form-control-position field-icon">
                      <a @click="showPassword">
                        <feather-icon :icon="icon" class="top-4 " svgClasses="w-5 h-5 icon-color"></feather-icon>
                      </a>
                    </div>

                    <div class="flex flex-wrap justify-between my-5">
                        <router-link to="/forgot-password">¿Olvidaste tu contraseña?</router-link>
                    </div>
                    <input type="submit" style="position: absolute; left: -9999px"/>
                    <vs-button :disabled="status.loggingIn" ref="loadableButton" id="button-with-loading" class="vs-con-loading__container float-right" @click="submitLogin" type="relief" vslor="primary">Iniciar</vs-button>
                    <vs-button  type="border" to="/register">Registrate gratis</vs-button>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import router from "../../../../router";

export default{
  data() {
    return {
      icon: 'EyeIcon',
      type: 'password',
      email: "",
      password: "",
      checkbox_remember_me: false
    }
  },
  created() {
    this.logout()
  },
  computed: {
    ...mapState('account', ['status']),
  },
  methods: {

    showPassword() {
      if(this.type === 'password') {
        this.type = 'text'
        this.icon = 'EyeOffIcon'
      } else {
        this.type = 'password'
        this.icon = 'EyeIcon'
      }
    },
    ...mapActions('account', ['login', 'logout']),
    submitLogin(e) {
      if (e) {
        e.preventDefault();
      }
      const {email, password} = this;
      this.$store.dispatch("alert/clear", {});
      if (email && password) {
        this.$vs.loading({
          background: 'primary',
          color: '#fff',
          container: "#button-with-loading",
          scale: 0.45
        });
        this.login({email, password, aclChangeRole: this.$acl.change})
        .then(
          () => {
            this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          },
          error => {
            this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          }
        )
      } else {
        this.$store.dispatch("alert/error", "Ingrese los datos requeridos");
      }
    }

  }
}
</script>

<style>
.vs-button-primary.vs-button-relief {
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
